import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import BannerSettingsForm from '../../../components/siteadmin/BannerSettingsForm';
import Loader from '../../../components/Loader';
import { withQuery } from '../../../hoc/withGraphql';

import s from './BannerSettings.css';

const BannerSettings = (props) => {

  const { data: { loading, getBanner }, title } = props;

  if (loading) {
    return <Loader type={"text"} />;
  } else {
    const bannerData = {
      ...getBanner,
      dynamicBanner: getBanner?.dynamicBanner?.length > 0 ? getBanner.dynamicBanner : [{
        language: 'en',
        title: getBanner?.title,
        content: getBanner?.content
      }]
    };
    return <BannerSettingsForm initialValues={bannerData} title={title} image={getBanner?.image} id={getBanner?.id} />
  }
}

BannerSettings.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getBanner: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      content: PropTypes.string,
      dynamicBanner: PropTypes.array,
    }),
  }),
};

BannerSettings.defaultProps = {
  data: {
    loading: true
  }
};

export default compose(
  withStyles(s),
  withQuery(gql`
        {
          getBanner {
            id
            title
            content
            image
            dynamicBanner {
              id
              bannerId
              language
              title
              content
            }
          }
        }
      ` , {
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }
  ),
)(BannerSettings);
